<template>
  <div>
    <router-view v-if="route.name === 'iframe'" />
    <v-app v-else>
      <AutoEnrollInfoModal />
      <v-main class="main-background">
        <TopBar class="pb-3" />
        <!-- <v-container id="container" :class="[noPadding && 'no-padding']"> -->
        <router-view />
        <AlertDisplay />
        <!-- </v-container> -->
      </v-main>
    </v-app>
  </div>
</template>

<script setup lang="ts">
import TopBar from '@/components/TopBar.vue'

import AlertDisplay from './components/AlertDisplay.vue'
import AutoEnrollInfoModal from './components/AutoEnrollInfoModal.vue'
import { useRoute } from 'vue-router/composables'
import { computed, provide } from 'vue'
import { app } from './main'
import { vuetifyKey } from './utils/injectionKeys'
const route = useRoute()

provide(vuetifyKey, app.$vuetify)
const noPadding = computed(() => useRoute().path.includes('funnel'))
</script>

<style lang="scss" scoped>
.main-background {
  background: #f5f5f5;
  background-repeat: repeat-y;
  background-size: contain;
}
</style>
